export enum ELoginEnum {
  id = '아이디를 제대로 입력해주세요',
  pw = '비밀번호를 제대로 입력해주세요',
  easyPw = '간편비밀번호를 입력해주세요',
  }
